angular.module('aprima-core-ui').directive('apKeyboardSpace',
    ['Bridge', 'DeviceSettings',
        function (Bridge, DeviceSettings) {
            'use strict';

            var keyboardHeight=0;

            return {
                restrict: 'EA',
                link: function ($scope) {
                    Bridge.on('keyboard-open', $scope, function (data) {
                        //Native is focused
                        if (document.activeElement.tagName.toUpperCase()==='BODY') {
                            if (DeviceSettings.isPhone) {
                                //the height of the menu on the bottom is 48px on phones
                                keyboardHeight = data.KeyboardHeight - 48;
                            }
                            else {
                                keyboardHeight = data.KeyboardHeight;
                            }
                            document.getElementById('keyboardspace').style.height = keyboardHeight + 'px';
                            $scope.$broadcast('keyboard-opened', {
                                keyboardHeight: keyboardHeight
                            });
                        }
                        else { //webview is focused
                            if (DeviceSettings.isIos) {
                                $scope.$broadcast('keyboard-focus');
                            }
                        }
                    });

                    Bridge.on('keyboard-close', $scope, function () {
                        document.getElementById('keyboardspace').style.height = '0px';
                        $scope.$broadcast('keyboard-closed');
                    });
                },
                template: '<div id="keyboardspace"></div>'
            };
        }]);